import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

console.log('Bookshelf Game React JS Loaded!');

function renderApp() {
  const container = document.getElementById('bookshelf-game-root') || document.getElementById('root');
  console.log('Root Container (in renderApp):', container);
  if (container) {
    ReactDOM.createRoot(container).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    console.log('React rendered!');
  } else {
    setTimeout(renderApp, 100);
  }
}

if (document.readyState === "complete" || document.readyState === "interactive") {
  setTimeout(renderApp, 100);
} else {
  window.addEventListener('DOMContentLoaded', function() {
    setTimeout(renderApp, 100);
  });
}
